import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { NewSnackbarService } from "src/app/services/snackbar-new.service";
import { SnackbarTemplateComponent } from "../snackbar-template.component";

@Component({
  selector: "app-default-snackbar",
  imports: [],
  templateUrl: "./default-snackbar.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./default-snackbar.component.less",
})
export class DefaultSnackbarComponent extends SnackbarTemplateComponent {
  public snackbar = inject(NewSnackbarService);
  public constructor() {
    super();
  }
}
